<section [hidden]="isPwdUpdateVisible" class="simulation grid-container login-page" id="loginPage" data-overload-controller="LoginPegaseCtrl">
    <div>
        <div class="page-header">
            <p class="simulation__panelTitle page-title">
                {{ 'accountactivation.title' | i18n }}
            </p>
            <div *ngIf="this.defaultCaisse" class="hide-mobile login-page__caisse">
                <div class="login-page__caisseTitle">
                    {{ this.defaultCaisse.name }}
                </div>
            </div>
        </div>
        <div *ngIf="isLoggedOut" class="login-page__subtitle">
            {{ 'login.subtitle' | i18n }}
        </div>
        <div class="login-page__content">
            <form [formGroup]="loginForm" (ngSubmit)="login()" class="">
                <div class="login-page__block">
                    <div class="grid-12 login-page__input">
                        <label class="grid-3 grid-mobile-4" for="phone">
                            {{ 'login.form.label.login' | i18n }}:

                            <span id="identifiant_tooltip" class="hide-desktop tooltip--toparrow tooltip--right tooltip--textleft" [attr.data-cand-tooltip]="'login.form.login.tooltip' | i18n: ''">
                                <span class="tooltip_arrow"></span>
                                <span class="icon icon--info"></span>
                            </span>
                        </label>
                        <input class="grid-6 grid-mobile-4 textfield" id="phone" formControlName="phone" name="phone" pattern="^(?!00)[0-9]{10,15}$" maxlength="15" type="tel" required="" />
                        <span
                            class="hide-mobile tooltip--toparrow login-page__tooltip tooltip--textright"
                            data-tag-commander=""
                            [appTagCommander]="'tagCo.login.tooltip.username'"
                            [attr.data-cand-tooltip]="'login.form.login.tooltip' | i18n: ''"
                        >
                            <span class="tooltip_arrow"></span>
                            <span class="icon icon--info"></span>
                        </span>
                    </div>
                    <div class="grid-12">
                        <a
                            id="forgot_login_link"
                            class="grid-6 push-3 grid-mobile-4 push-mobile-0 login-box__link--right"
                            data-tag-commander=""
                            [appTagCommander]="'tagCo.login.resetusername.button'"
                            data-ui-sref="root.resetusername"
                            routerLink="/identifiant-oublie"
                            >{{ 'login.resetpassword.link1' | i18n }}
                        </a>
                    </div>

                    <div class="grid-12 login-page__input">
                        <label class="grid-3 grid-mobile-4" for="password"> {{ 'login.form.label.password' | i18n }}: </label>
                        <input type="password" name="password" formControlName="password" class="grid-6 grid-mobile-4 textfield" id="password" required="" />
                    </div>
                    <div class="grid-12">
                        <span id="forgot_password_link" (click)="openResetPassword()" data-tag-commander="" [appTagCommander]="'tagCo.login.resetpassword.button'" class="grid-6 push-3 grid-mobile-4 push-mobile-0 login-box__link--right">
                            {{ 'login.resetpassword.link' | i18n }}
                        </span>
                    </div>
                    <app-caisse-auto-complete [id]="'caisseLogin'" [form]="loginForm" [defaultCaisse]="defaultCaisse" (caisseSelected)="handleCaisseSelection($event)"></app-caisse-auto-complete>
                </div>
                <div class="grid-12 login-page__input simulation__group login-page__block login-page__button">
                    <button id="connexion_btn" type="submit" [ngClass]="{ 'icon--loading': isLoading }" class="grid-6 push-3 grid-mobile-4 push-mobile-0 button button--primary" data-api-call-button="" [disabled]="!loginForm.valid">
                        {{ 'login.form.button.connexion' | i18n }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>

<section [hidden]="!isPwdUpdateVisible" class="simulation grid-container login-page" id="resetQuery">
    <div>
        <p class="simulation__panelTitle page-title">
            {{ 'accountactivation.title' | i18n }}
        </p>
        <div class="login-page__subtitle">
            {{ 'login.resetpassword.subtitle' | i18n }}
        </div>

        <div class="login-page__content">
            <form [formGroup]="resetPwdQueryForm" method="POST" name="resetForm" novalidate="" (ngSubmit)="validateResetQuery()" class="">
                <div class="login-page__block">
                    <div class="grid-12 login-page__input">
                        <label class="grid-3 grid-mobile-4" for="resetUsername"> {{ 'login.resetpassword.form.label.email' | i18n }}: </label>
                        <input type="email" class="grid-6 grid-mobile-4 textfield textfield--full" id="resetUsername" name="resetUsername" formControlName="email" />
                    </div>
                    <app-caisse-auto-complete [id]="'caisseResetPwd'" [form]="resetPwdQueryForm" [defaultCaisse]="defaultCaisse" (caisseSelected)="handleCaisseSelection($event)"> </app-caisse-auto-complete>
                </div>
                <div class="grid-12">
                    <span *ngIf="resetPwdQuerySuccess === true" class="grid-8 push-3 grid-mobile-4 push-mobile-0 form-message--tiny form-message--no-margin form-message--success">
                        {{ 'login.resetpassword.success' | i18n }}
                    </span>
                    <span *ngIf="resetPwdQuerySuccess === false" class="grid-8 push-3 grid-mobile-4 push-mobile-0 form-message--tiny form-message--no-margin form-message--error">
                        {{ 'login.resetpassword.fail' | i18n }}
                    </span>
                    <!-- ngIf: login.isDirtyAndInvalid -->
                </div>
                <div class="grid-12 login-page__input simulation__group login-page__block login-page__button">
                    <div class="grid-6 grid-mobile-4 hide-mobile">
                        <button (click)="goBackToLogin()" data-tag-commander="" [appTagCommander]="'tagCo.resetpassword.previous.button'" class="button button--grey button--previous float-left" type="reset">
                            {{ 'login.resetpassword.login' | i18n }}
                        </button>
                    </div>
                    <div class="grid-6 grid-mobile-2 no-gutter-mobile">
                        <button
                            type="submit"
                            class="button button--primary button--next float-right"
                            data-tag-commander=""
                            [appTagCommander]="'tagCo.resetpassword.validate.button'"
                            data-api-call-button=""
                            [disabled]="!resetPwdQueryForm.valid"
                            [ngClass]="{ 'icon--loading': resetPasswordLoading }"
                        >
                            {{ 'login.resetpassword.button.reset' | i18n }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
